<app-itinerary-preview [reviewIntent]="true"></app-itinerary-preview>
